// src/utils/urlUtils.js
export const createMovieSlug = movie => {
  if (!movie || !movie.title) return '';

  // Create SEO-friendly slug: "123-the-matrix-1999"
  const titleSlug = movie.title
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single
    .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens

  return `${movie.display_id}-${titleSlug}-${movie.year}`;
};

// ADD: Create release slug function
export const createReleaseSlug = (movie, release) => {
  if (!movie || !movie.title || !release) return '';

  const titleSlug = movie.title
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  // Use display_id (the numeric ID like 159)
  return `${release.display_id}-${titleSlug}-${movie.year}`;
};

export const parseMovieSlug = slug => {
  if (!slug) return null;

  // Extract ID from slug: "123-the-matrix-1999" -> 123
  const match = slug.match(/^(\d+)-/);
  return match ? parseInt(match[1]) : null;
};

// ADD: Parse release ID from slug
export const parseReleaseSlug = slug => {
  if (!slug) return null;

  // Extract ID from slug: "87-alien-1979" -> 87
  const match = slug.match(/^(\d+)-/);
  return match ? parseInt(match[1]) : null;
};

// CHANGE: Remove /movie/ from URL
export const generateMovieUrl = (movie, context = 'catalog') => {
  const slug = createMovieSlug(movie);
  return `/${context}/${slug}`;
};

// ADD: Generate release URL
export const generateReleaseUrl = (movie, release) => {
  const slug = createReleaseSlug(movie, release);
  return `/catalog/release/${slug}`;
};

// LEGACY: Keep old parseReleaseUrl for backward compatibility
export const parseReleaseUrl = params => {
  if (params.slug) {
    return {
      releaseId: parseReleaseSlug(params.slug),
      movieSlug: null,
      releaseSlug: null,
    };
  }

  if (params.movieSlug && params.releaseSlug && params.releaseId) {
    return {
      releaseId: parseInt(params.releaseId),
      movieSlug: params.movieSlug,
      releaseSlug: params.releaseSlug,
    };
  }

  return { releaseId: null, movieSlug: null, releaseSlug: null };
};
